module.exports = __webpack_public_path__ + "img/08.e0f4df9e.png";